import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../assets/img/buypower-logo.png"
import chat from "../assets/img/chat-img.svg"
import liveChat from "../assets/img/Livechat.svg"
import Facebook from "../assets/img/Facebook.svg"
import Whatsapp from "../assets/img/Whatsapp.svg"
import Group from "../assets/img/Group.png"

import { openChatWidget } from '../livechat';


const ContactService = () => {
  return (
    <div className="ContactService">
      <div className="ContactService__header">
        <div>
          <div className="ContactService__header__logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="u-flex">
            <Link to="/faq">FAQ</Link>
            <a href="#support-channels">Contact Us</a>
            <a href="tel:+2342012293044">
              <img src={Group} alt="telephone" />
            </a>
          </div>
        </div>
      </div>
      <div className="ContactService__body">
        <div className="ContactService__body--1">
          <div>
            <p>
              <span className="break">
                Here at <span className="u-margin-y">Buy</span>
                <span className="u-margin-g">Power,</span>
              </span>
              <span className="break"> we care about</span> serving you
            </p>
            <span className="u-margin-sp">
              Enjoy our customer service and have your issues
              <br /> resolved anytime - day and night.
            </span>
          </div>
          <div className="ContactService__body__chat">
            <a id="support-channels">&nbsp;</a>
            <img onClick={openChatWidget} src={chat} alt="hi" />
          </div>
        </div>
        <div className="ContactService__body--2">
          <p>Support Channels</p>
          <p className="u-fm">Choose from our available support channels</p>
          <div className="ContactService__body__support">
            <div>
              <a href="https://wa.me/2347069435037?text=Hello" target="_new">
                <img src={Whatsapp} alt="freshchat whatsapp" />
              </a>
              <p>Whatsapp</p>
              <span>
                Feel more connected as you relate to BuyPower like you would
                your best Buddy.
              </span>
              <a href="https://wa.me/2347069435037?text=Hello" target="_new">
                Chat Now &rarr;
              </a>
            </div>
            <div>
              <a href="http://m.me/buyelectricity" target="_new">
                <img src={Facebook} alt="freshchat facebook" />
              </a>
              <p>Facebook</p>
              <span>
                Get in touch even while you are catching up with your friends on
                Facebook.
              </span>
              <a href="http://m.me/buyelectricity" target="_new">
                Chat Now &rarr;
              </a>
            </div>
            <div>
              <a>
                <img src={liveChat} alt="Livechat" />
              </a>
              <p>Live Chat</p>
              <span>
                Keep an eye out for our live chat bubble. We’re always available
                to meet your support needs.
              </span>
              <a onClick={openChatWidget}>Chat Now &rarr;</a>
            </div>
          </div>
        </div>
        <div className="ContactService__body--3">
          <div>
            <div>
              <p>Get in touch with Support</p>
            </div>
          </div>
          <div>
            <a href="tel:+2342012293044" className="u-mgb">
              Call Now (0201-229-3044)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactService;


// WEBPACK FOOTER //
// ./src/components/ContactService.js